// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ethical-code_wrapper__0V9P3","wrapper__label":"ethical-code_wrapper__label__BPvEd"};